import type { ReactNode } from 'react'

interface Props {
  color?: string
}

export function NoteIcon({ color = '#8a1568' }: Props): ReactNode {
  return (
    <svg width="15" height="15" viewBox="0 0 64 60">
      <path
        fill={color}
        d="M6.5 60H45.5C47.2 60 48.9 59.3 50.1 58.1 51.3 56.9 52 55.3 52 53.6V32.1C52 31.6 51.7 31 51.3 30.6 50.9 30.2 50.4 30 49.8 30 49.2 30 48.7 30.2 48.3 30.6 47.9 31 47.6 31.6 47.6 32.1V53.6C47.6 54.1 47.4 54.7 47 55.1 46.6 55.5 46.1 55.7 45.5 55.7H6.5C5.9 55.7 5.4 55.5 5 55.1 4.6 54.7 4.3 54.1 4.3 53.6V10.7C4.3 10.1 4.6 9.6 5 9.2 5.4 8.8 5.9 8.6 6.5 8.6H32.5C33.1 8.6 33.6 8.3 34 7.9 34.4 7.5 34.6 7 34.6 6.4 34.6 5.9 34.4 5.3 34 4.9 33.6 4.5 33.1 4.3 32.5 4.3H6.5C4.8 4.3 3.1 5 1.9 6.2 0.7 7.4 0 9 0 10.7V53.6C0 55.3 0.7 56.9 1.9 58.1 3.1 59.3 4.8 60 6.5 60Z"
      />

      <path
        fill={color}
        d="M52.3 0C51.3 0 50.2 0.2 49.2 0.6 48.2 1 47.3 1.6 46.5 2.4L18 30.6C17.7 30.9 17.5 31.2 17.4 31.5L13.1 44.3C13 44.6 13 45 13 45.3 13.1 45.7 13.2 46 13.4 46.3 13.6 46.5 13.9 46.8 14.2 46.9 14.5 47.1 14.8 47.1 15.2 47.1 15.4 47.1 15.6 47.1 15.8 47L28.8 42.7C29.2 42.6 29.4 42.5 29.7 42.2L58.2 14C59.4 12.9 60.2 11.4 60.5 9.8 60.8 8.2 60.6 6.6 60 5.1 59.4 3.6 58.3 2.3 57 1.4 55.6 0.5 54 0 52.3 0ZM55.1 11L27 38.8 18.6 41.6 21.4 33.3 49.5 5.4C50.1 4.9 50.8 4.5 51.6 4.4 52.3 4.2 53.1 4.3 53.9 4.6 54.6 4.9 55.2 5.4 55.6 6 56.1 6.7 56.3 7.4 56.3 8.2 56.3 8.7 56.2 9.2 56 9.7 55.8 10.2 55.5 10.6 55.1 11Z"
      />
    </svg>
  )
}
